import './mobile-menu';
import './header-scroll';
import './phone-number-cta';
function lordiags_no_break() {
    // Version simple qui préserve les event listeners
    const content = document.body.textContent;
    const pattern = /Lor[^a-zA-Z]N\s+Diags/gi;
    const replacement = 'Lor\'N\u00A0Diags'; // \u00A0 = espace insécable
    
    if (pattern.test(content)) {
        // Parcourir tous les éléments et remplacer le texte
        const allElements = document.querySelectorAll('*');
        allElements.forEach(element => {
            if (element.children.length === 0) { // Seulement les éléments sans enfants
                if (element.textContent && pattern.test(element.textContent)) {
                    element.textContent = element.textContent.replace(pattern, replacement);
                }
            }
        });
    }
}

// Exécute immédiatement
lordiags_no_break();

// Exécute après le chargement complet de la page
document.addEventListener('DOMContentLoaded', lordiags_no_break);
// Exécute après le chargement de tous les éléments (images, etc.)
window.addEventListener('load', lordiags_no_break);

